import { gql } from '@apollo/client';

export const LIST_LANGUAGE = gql`
  query List {
    listLanguage {
      list {
        id
        name
      }
    }
  }
`;
